// extracted by mini-css-extract-plugin
export default {"imageWrap":"styles_imageWrap__jIVuS","textWrap":"styles_textWrap__YYjCg"};